import { MetadataUtils } from '../types/metadata_utils';
import {
  getClientUserAgent,
  getDocumentReferrer,
  getDocumentTitle,
  getWindowLocationHostname,
  getWindowLocationHref,
  getWindowLocationPathname,
  getWindowLocationPort,
  getWindowLocationSearch,
  isPageVisible,
} from './window_helper';

export const browserMetadataUtils: MetadataUtils = {
  getClientUserAgent: () => getClientUserAgent(),
  getDocumentTitle: () => getDocumentTitle(),
  getDocumentReferrer: () => getDocumentReferrer(),
  getWindowLocationHostname: () => getWindowLocationHostname(),
  getWindowLocationHref: () => getWindowLocationHref(),
  getWindowLocationPathname: () => getWindowLocationPathname(),
  getWindowLocationPort: () => getWindowLocationPort(),
  getWindowLocationSearch: () => getWindowLocationSearch(),
  isPageVisible: () => isPageVisible(),
};
